import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useRegisterMutation } from "@features/auth/authApi";
import InputWrapper from "@common/components/InputWrapper";
import logoImage from "@assets/images/learningportal.svg";

const Register = () => {
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [register, { isLoading, error }] = useRegisterMutation();

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const resetForm = () => {
    setData({
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
    });
  };

  useEffect(() => {
    if (error?.data) {
      toast.error(error.data);
    }
  }, [error, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (data?.password !== data?.confirmPassword) {
      toast.error('Password does not match!');
      return;
    }
    const response = await register({
      name: data?.name,
      email: data?.email,
      role: "student",
      password: data?.password,
    });
    if (response?.data) {
      resetForm();
      navigate("/course");
      toast.success("Student registered in successfully!");
    }
  };

  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img className="h-12 mx-auto" src={logoImage} alt="logo" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Create Your New Account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" value="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <InputWrapper
              id="name"
              name="name"
              type="text"
              autoComplete="name"
              required
              className="login-input rounded-t-md"
              placeholder="Student Name"
              value={data?.name}
              onChange={handleChange}
            />

            <InputWrapper
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="login-input"
              placeholder="Email address"
              value={data?.email}
              onChange={handleChange}
            />

            <InputWrapper
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              className="login-input"
              placeholder="Password"
              value={data?.password}
              onChange={handleChange}
            />

            <InputWrapper
              id="confirm-password"
              name="confirmPassword"
              type="password"
              autoComplete="confirm-password"
              required
              className="login-input rounded-b-md"
              placeholder="Confirm Password"
              value={data?.confirmPassword}
              onChange={handleChange}
            />
          </div>
          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              Create Account
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Register;
